import React, { Component } from 'react';
import Quagga from 'quagga';


class Scanner extends Component {
    constructor(props){
        super(props);
        this._onDetected = this._onDetected.bind(this);
    }
    state = {  } 
    render() { 
        return (
            <div id="interactive" className="viewport">
                <hr className="barcode-liner" />
            </div>
        );
    }
    componentDidMount() {
        Quagga.init({
            inputStream: {
                size: 1920,
                type : "LiveStream",
                constraints: {
                    width: 640,
                    height: 480,
                    facingMode: "environment"
                }
            },
            locator: {
                patchSize: "x-large",
                halfSample: true
            },
            numOfWorkers: 0,
            decoder: {
                readers : [ 
                    "code_128_reader"
                ]
            },
            area: { // defines rectangle of the detection/localization area
              top: 0,    // top offset
              right: 0,  // right offset
              left: 0,   // left offset
              bottom: 0  // bottom offset
            },
            debug: {
              showCanvas: true,
              showPatches: true,
              showFoundPatches: true,
              showSkeleton: true,
              showLabels: true,
              showPatchLabels: true,
              showRemainingPatchLabels: true,
              boxFromPatches: {
                showTransformed: true,
                showTransformedBox: true,
                showBB: true
              }
            },
            locate: false
        }, function(err) {
            if (err) {
                return console.log(err);
            }
            Quagga.start();
        });
        Quagga.onDetected(this._onDetected);
    }
    componentWillUnmount() {
        Quagga.offDetected(this._onDetected);
    }
    _onDetected(result) 
    {
        if (result != null){
            const serialnumber_text = result.codeResult.code;
            if (serialnumber_text.length >= 18 && serialnumber_text.length <= 21)
            {
                this.props.onDetected(result);
            }
        }
    }
}
 
export default Scanner;